const env    = require("app/services/env")
const axios  = require("axios")
const router = require('app/services/router')

class SegmentTracking {

  getProductClickedEvents(productId) {
      let route = router.route("api.tracking.product-clicked");
      let data = {
        cart_id: env.get("checkout.cart.products.guid"),
        product_id: productId,
      }

      let eventToAttach = e => this.linkEvent(e, route, data);

      return {
        onClick: eventToAttach,
        onAuxClick: eventToAttach,
      }
  }

  linkEvent(event, route, data) {

    let link = event.currentTarget;

    let href = link.getAttribute('href')
      || link.getAttributeNS('http://www.w3.org/1999/xlink', 'href')
      || link.getAttribute('xlink:href');

    let preventingDefault = false;

    if (href && link.target !== '_blank' && !this.isMaybeOpeningInNewTab(event)) {
      preventingDefault = true;
      event.preventDefault();
    }

    return Promise.resolve()
      .then(() => {
        return axios.post(route, data);
      })
      .then(() => {
        if (preventingDefault === true) {
          window.location.href = href;
        }
      });
  }

  isMaybeOpeningInNewTab(event) {
    if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey || event.which === 2 || event.button >= 1) {
      return true;
    }

    return false;
  }

}

module.exports = new SegmentTracking();
